import { call, take } from 'redux-saga/effects';
import axios          from 'axios';

const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/updateApproved.php';

function* updateApproved(): Generator<any,any,any> {
  while(true) {
    try {

        const userInput      = yield take('UPDATE_APPROVED_SAGA');
        const { id, newVal } = userInput.payload;
        
        if (process.env.NODE_ENV === 'development') {

          console.log('id     : ',id)
          console.log('newVal : ',newVal)

        }
        if (process.env.NODE_ENV === 'production') {
            

            const update = yield call( axios.post, endpoint, {id: id, newVal: newVal });

            if (update && update.data) {

               console.log(update.data)
            }

            else {
              console.log("can't update approved")
            }
        }
    }
    catch(err) {
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default updateApproved;






